import React, { useEffect, useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { BiPlus } from "react-icons/bi";
import { axios } from "../../../../../../../Global";
import {
  setAppError,
  setBreadCrumb,
} from "../../../../../../../store/userSlice";
import LoadingWithLable from "../../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ContractCPCostSheetAddNew from "./CPCostSheetAddNew";
// import CostPlusCreate from "./CostPlusCreate/CostPlusCreate";
// import CostPlusAddNew from "./CostPlusCreate/CostPlusAddNew";

export default function ContractCostSheetAddNew() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { breadCrumbs } = useSelector((state) => state.user);
  const params = useParams();
  // const quotationId = location.pathname.split("/").at(-2);
  const contractId = params.contractId;
  const quotationId = params.quotationId;

  const costDivide = (cost, value) => {
    if (cost == 0) return +cost;
    return Number(+cost / +value).toFixed(2);
  };

  const [quotationDetails, setQuotationDetails] = useState({});

  const [costSheetDataLoading, setCostSheetDataLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [costSheetDefault, setCostSheetDefault] = useState({});
  const [selectDatas, setSelectDatas] = useState();
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-orange-400",
      bgSecondary: "bg-orange-200",
    },
    {
      rate_category_id: 2,
      title: "GOVERNMENT FEES (PER MONTH)",
      bgPrimary: "bg-cyan-700",
      bgSecondary: "bg-cyan-200",
    },
    {
      rate_category_id: 3,
      title: "SOUNDLINE FEES (ACTUALS & PER MONTH)",
      bgPrimary: "bg-green-800",
      bgSecondary: "bg-green-200",
    },
  ];
  const [employeeSalaryPackageCols, setEmployeeSalaryPackageCols] = useState(
    []
  );
  const [govermentFeesCols, setGovermentFeesCols] = useState([]);
  const [soundLineFeesCols, setSoundLineFeesCols] = useState([]);

  const [allRows, setAllRows] = useState([
    {
      id: 1,
      job_position_id: "",
      visa_profession_id: "",
      profession_level_id: "",
      gender: "",
      nationality_id: "",
      quantity: "",
      sections: [
        {
          rate_category_id: 1,
          columns: [],
        },
        {
          rate_category_id: 2,
          columns: [],
        },
        {
          rate_category_id: 3,
          columns: [],
        },
      ],
    },
  ]);

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };

  useEffect(() => {
    axios
      .get(`/dashboard/contract/${contractId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const result = res.data.data;
        setSelectDatas(result);
        const quotation = result?.contract || {};
        setQuotationDetails(quotation);
        const allHeadings = result.contract_cost_sheet_headings;

        allRows.map((row) =>
          row.sections.map((section, index) => {
            section.columns = allHeadings
              .filter(
                (heading) =>
                  heading.rate_category_id == section.rate_category_id
              )
              .map((heading) => ({
                id: heading?.id,
                rate_category_id: heading?.rate_category_id,
                rate_category_item_id: heading?.rate_category_item_id,
                rate_category_item_name:
                  heading?.rate_category_item_name ||
                  heading?.rate_category_item?.name,
                type: heading?.type,
                cost:
                  heading?.type == "24 Months"
                    ? costDivide(heading?.rate_category_item?.cost, 24)
                    : heading?.type == "12 Months"
                    ? costDivide(heading?.rate_category_item?.cost, 12)
                    : heading?.rate_category_item?.cost,
              }));
            if (section.rate_category_id == 2) {
              section.columns.find((column) => {
                if (column.rate_category_item_name == "END OF SERVICE") {
                  column.cost = Number(
                    (Number(
                      row.sections
                        .find((section) => section.rate_category_id == 1)
                        .columns.find(
                          (column) => column.rate_category_item_name == "BASIC"
                        ).cost
                    ) /
                      30) *
                      (15 / 12)
                  ).toFixed(2);
                }
                if (column.rate_category_item_name == "VACATION SALARY") {
                  column.cost = Number(
                    (Number(
                      row.sections
                        .find((section) => section.rate_category_id == 1)
                        .columns.find(
                          (column) => column.rate_category_item_name == "BASIC"
                        ).cost
                    ) /
                      30) *
                      (21 / 12)
                  ).toFixed(2);
                }
              });
            }
            if (section.rate_category_id == 3) {
              section.columns.find((column) => {
                if (column?.rate_category_item_name == "GOSI") {
                  column.cost = Number(
                    ((Number(
                      row.sections
                        .find((section) => section.rate_category_id == 1)
                        .columns.find(
                          (column) => column.rate_category_item_name == "BASIC"
                        ).cost
                    ) +
                      Number(
                        row.sections
                          .find((section) => section.rate_category_id == 1)
                          .columns.find(
                            (column) => column.rate_category_item_name == "HRA"
                          ).cost
                      )) *
                      2) /
                      100
                  ).toFixed(2);
                }
                if (column?.rate_category_item_name == "NITAKAT") {
                  column.cost = 0;
                }
                if (column?.rate_category_item_name == "ADMIN FEE") {
                  column.cost = 0;
                }
                if (
                  column?.rate_category_item_name == "SOUNDLINE SERVICE FEE"
                ) {
                  column.cost = 0;
                }
              });
              // section.columns.splice(2, 0, {
              //   id: Math.floor(Math.random() * 10000),
              //   rate_category_id: section.rate_category_id,
              //   rate_category_item_name: "GOSI",
              //   cost: Math.round(
              //     (Number(
              //       row.sections
              //         .find((section) => section.rate_category_id == 1)
              //         .columns.find(
              //           (column) => column.rate_category_item_name == "BASIC"
              //         ).cost
              //     ) *
              //       2) /
              //       100
              //   ),
              //   title: "GOSI",
              //   default: true,
              //   type: "Dynamic",
              // });
              // section.columns.push(
              //   {
              //     id: Math.floor(Math.random() * 10000),
              //     rate_category_id: section.rate_category_id,
              //     rate_category_item_name: "NITAKAT",
              //     cost: 0,
              //     title: "NITAKAT",
              //     default: true,
              //     type: "Dynamic",
              //   },
              //   {
              //     id: Math.floor(Math.random() * 10000),
              //     rate_category_id: section.rate_category_id,
              //     rate_category_item_name: "ADMIN FEE",
              //     cost: 0,
              //     title: "ADMIN FEE",
              //     default: true,
              //     type: "Dynamic",
              //   },
              //   {
              //     id: Math.floor(Math.random() * 10000),
              //     rate_category_id: section.rate_category_id,
              //     rate_category_item_name: "SOUNDLINE SERVICE FEE",
              //     cost: 0,
              //     title: "SOUNDLINE SERVICE FEE",
              //     default: true,
              //     type: "Dynamic",
              //   }
              // );
            }
            // if (section.rate_category_id == 3) {
            //   section.columns.splice(2, 0, {
            //     id: Math.floor(Math.random() * 10000),
            //     rate_category_id: section.rate_category_id,
            //     rate_category_item_name: "GOSI",
            //     cost: Math.round(
            //       (Number(
            //         row.sections
            //           .find((section) => section.rate_category_id == 1)
            //           .columns.find(
            //             (column) => column.rate_category_item_name == "BASIC"
            //           ).cost
            //       ) *
            //         2) /
            //         100
            //     ),
            //     title: "GOSI",
            //     default: true,
            //     type: "Dynamic",
            //   });
            //   section.columns.push(
            //     {
            //       id: Math.floor(Math.random() * 10000),
            //       rate_category_id: section.rate_category_id,
            //       rate_category_item_name: "NITAKAT",
            //       cost: 0,
            //       title: "NITAKAT",
            //       default: true,
            //       type: "Dynamic",
            //     },
            //     {
            //       id: Math.floor(Math.random() * 10000),
            //       rate_category_id: section.rate_category_id,
            //       rate_category_item_name: "ADMIN FEE",
            //       cost: 0,
            //       title: "ADMIN FEE",
            //       default: true,
            //       type: "Dynamic",
            //     },
            //     {
            //       id: Math.floor(Math.random() * 10000),
            //       rate_category_id: section.rate_category_id,
            //       rate_category_item_name: "SOUNDLINE SERVICE FEE",
            //       cost: 0,
            //       title: "SOUNDLINE SERVICE FEE",
            //       default: true,
            //       type: "Dynamic",
            //     }
            //   );
            // }
          })
        );
        setEmployeeSalaryPackageCols(allRows[0].sections[0].columns);
        setGovermentFeesCols(allRows[0].sections[1].columns);
        setSoundLineFeesCols(allRows[0].sections[2].columns);
        setCostSheetDefault(result);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setCostSheetDataLoading(false);
      });
  }, []);

  useEffect(
    function addBreadCrumb() {
      const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
        (crumb) => crumb.label === "ADD NEW COST SHEET"
      );

      if (!isEditCostSheetInBreadcrumbs) {
        dispatch(
          setBreadCrumb([
            ...breadCrumbs,
            { label: "ADD NEW COST SHEET", link: `` },
          ])
        );
      }
    },
    [location.pathname, selectDatas, tableHeading]
  );

  const handleCreateRow = () => {
    setAllRows((prev) => [
      ...prev,
      {
        id: Math.floor(Math.random() * 1000),
        job_position_id: "",
        visa_profession_id: "",
        profession_level_id: "",
        gender: "",
        nationality_id: "",
        quantity: "",
        sections: [
          {
            rate_category_id: 1,
            columns: employeeSalaryPackageCols,
          },
          {
            rate_category_id: 2,
            columns: govermentFeesCols,
          },
          {
            rate_category_id: 3,
            columns: soundLineFeesCols,
          },
        ],
      },
    ]);
  };

  const handleDeleteRow = (rowId) => {
    setAllRows((prev) => {
      const updatedData = prev.filter((prevData) => prevData.id != rowId);
      if (updatedData.length != 0) {
        return updatedData;
      } else {
        return prev;
      }
    });
  };

  const handleUpdateColumn = (
    rowId,
    rate_category_id,
    columnId,
    updatedKey,
    updatedValue,
    columnName
  ) => {
    const updatedRows = allRows.map((row) => {
      let currentValueOfHRA = 0;
      let currentValueOfBasic = 0;
      if (updatedKey == "cost") {
        if (row.id == rowId) {
          const updatedSections = row.sections.map((section) => {
            if (section.rate_category_id == 1) {
              currentValueOfHRA = Number(
                section.columns.find(
                  (column) => column?.rate_category_item_name == "HRA"
                )?.cost
              );
            }
            if (section.rate_category_id == 1) {
              currentValueOfBasic = Number(
                section.columns.find(
                  (column) => column?.rate_category_item_name == "BASIC"
                )?.cost
              );
            }
            if (section.rate_category_id == rate_category_id) {
              const updatedColumns = section.columns.map((column) => {
                if (column.id == columnId) {
                  return { ...column, [updatedKey]: updatedValue };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            if (columnName == "BASIC" && section.rate_category_id == 2) {
              const updatedCostByEquation = section.columns.map((column) => {
                if (column?.rate_category_item_name == "END OF SERVICE") {
                  return {
                    ...column,
                    cost: Number(
                      (Number(updatedValue) / 30) * (15 / 12)
                    ).toFixed(2),
                  };
                } else if (
                  column?.rate_category_item_name == "VACATION SALARY"
                ) {
                  return {
                    ...column,
                    cost: Number(
                      (Number(updatedValue) / 30) * (21 / 12)
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedCostByEquation };
            }
            if (columnName == "BASIC" && section.rate_category_id == 3) {
              const updatedGosi = section.columns.map((column) => {
                if (column.rate_category_item_name == "GOSI") {
                  return {
                    ...column,
                    cost: Number(
                      ((Number(updatedValue) + Number(currentValueOfHRA)) * 2) /
                        100
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedGosi };
            }
            if (columnName == "HRA" && section.rate_category_id == 3) {
              const updatedGosi = section.columns.map((column) => {
                if (column.rate_category_item_name == "GOSI") {
                  return {
                    ...column,
                    cost: Number(
                      ((Number(updatedValue) + Number(currentValueOfBasic)) *
                        2) /
                        100
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedGosi };
            }
            return section;
          });
          return { ...row, sections: updatedSections };
        }
        return row;
      } else {
        const updatedSections = row.sections.map((section) => {
          if (section.rate_category_id == rate_category_id) {
            const updatedColumns = section.columns.map((column) => {
              if (column.id == columnId) {
                return { ...column, [updatedKey]: updatedValue };
              }
              return column;
            });
            return { ...section, columns: updatedColumns };
          }
          return section;
        });
        return { ...row, sections: updatedSections };
      }
    });

    setAllRows(updatedRows);
  };

  const handleUpdateRowProperties = (rowId, updatingKey, updatingValue) => {
    const updatedRows = allRows.map((row) => {
      if (row.id == rowId) {
        if (updatingKey == "profession_level_id") {
          const updatedSections = row.sections.map((section) => {
            if (section.rate_category_id == 3) {
              const updatedColumns = section.columns.map((column) => {
                if (column.rate_category_item_name == "NITAKAT") {
                  return {
                    ...column,
                    cost: costSheetDefault.profession_level.find(
                      (profession) => profession.id == updatingValue
                    )?.nitakat,
                  };
                }
                if (column.rate_category_item_name == "ADMIN FEE") {
                  return {
                    ...column,
                    cost: costSheetDefault.profession_level.find(
                      (profession) => profession.id == updatingValue
                    )?.admin_fee,
                  };
                }
                if (column.rate_category_item_name == "SOUNDLINE SERVICE FEE") {
                  return {
                    ...column,
                    cost: costSheetDefault.profession_level.find(
                      (profession) => profession.id == updatingValue
                    )?.soundline_fee,
                  };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            return section;
          });
          return {
            ...row,
            sections: updatedSections,
            [updatingKey]: updatingValue,
          };
        }
        return { ...row, [updatingKey]: updatingValue };
      }
      return row;
    });
    setAllRows(updatedRows);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const costSheet = [];
    for (let row of allRows) {
      const costSheetHeadingContent = [];
      for (let section of row.sections) {
        for (let column of section.columns) {
          costSheetHeadingContent.push({
            heading_id: column.id,
            cost: column.cost,
          });
        }
      }
      costSheet.push({
        ...{
          job_position_id: row.job_position_id,
          visa_profession_id: row.visa_profession_id,
          profession_level_id: row.profession_level_id,
          gender: row.gender,
          nationality_id: row.nationality_id,
          quantity: row.quantity,
        },
        heading: costSheetHeadingContent,
      });
    }
    const resultObj = {
      cost_sheet: costSheet,
    };

    axios
      .put(`/dashboard/contract-cost-sheet-add-new/${contractId}`, resultObj, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        dispatch(
          setAppError({
            msg: res?.data?.message || "Successfully created.",
            color: "success",
          })
        );
        navigate(`/dashboard/contract/${contractId}`, {
          state: { detailType: "COST SHEET" },
        });
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  return (
    <div className="!uppercase">
      <h2 className="text-2xl text-center font-bold mb-10">
        Quotation Cost Sheet
      </h2>
      {!costSheetDataLoading ? (
        <>
          <div className="text-sm mx-auto max-w-sm">
            <div className="text-left">
              <p>
                <b> Quotation No.</b>:{" "}
                {quotationDetails?.quotation?.quotation_number}
              </p>
              <p>
                <b>Quotation Name</b> : {quotationDetails?.quotation?.name}
              </p>
              <p>
                <b>Quotation Type</b> : {quotationDetails?.quotation_type?.name}
              </p>
              <p>
                <b>Client Name</b> : {quotationDetails?.client?.name}
              </p>
              <p
                className={`mb-1 ${
                  quotationDetails?.client?.client_specific?.length < 20
                    ? "flex"
                    : "block"
                }`}
              >
                <b>Client Specific </b> :
                {quotationDetails?.client?.client_specific}
              </p>
            </div>
          </div>

          <div className="flex flex-col w-full gap-1 my-12 overflow-x-scroll pl-16 pt-8">
            {quotationDetails?.quotation_type?.name === "Cost Plus" ? (
              <ContractCPCostSheetAddNew
                selectDatas={selectDatas}
                quotationId={quotationId}
              />
            ) : (
              <form onSubmit={handleSubmit} className="pb-5">
                {allRows.map((row, index) => (
                  <div key={row.id} className="flex gap-1 mt-1 ">
                    {row.sections.map((section, sectionIndex) => (
                      <div
                        className="flex flex-col relative"
                        key={section.rate_category_id}
                      >
                        {index == 0 && (
                          <>
                            <div
                              className={`w-full text-white py-2  ${tableHeading[sectionIndex].bgPrimary}`}
                            >
                              <h2 className="text-center">
                                {tableHeading[sectionIndex].title}
                              </h2>
                            </div>
                            <div className={`flex w-full gap-1 `}>
                              {section.rate_category_id == 1 && (
                                <>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    SL. NO.
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    ACTUAL PROFESSION
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    VISA PROFESSION
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    PROFESSION LEVEL
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    GENDER
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    NATIONALITY
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    QUANTITY
                                  </h3>
                                </>
                              )}
                              {section.columns.map((column) => (
                                <div
                                  key={column.id}
                                  className={`${tableHeading[sectionIndex].bgSecondary}  ${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative`}
                                >
                                  <h3 className="text-center text-sm">
                                    {column.rate_category_item_name}
                                  </h3>
                                </div>
                              ))}
                              <div
                                className={`${tableHeading[sectionIndex].bgSecondary}  ${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative`}
                              >
                                {section.rate_category_id == 1 && (
                                  <h3 className="text-center text-sm">
                                    Total Emp. Salary Package
                                  </h3>
                                )}
                                {section.rate_category_id == 2 && (
                                  <h3 className="text-center text-sm">
                                    Total Gov. Fees
                                  </h3>
                                )}
                                {section.rate_category_id == 3 && (
                                  <h3 className="text-center text-sm">
                                    Total Soundline Fees
                                  </h3>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="flex w-full gap-1 relative">
                          {section.rate_category_id == 1 && (
                            <>
                              <div className="flex gap-1 absolute -left-16">
                                {allRows.length - 1 == index && (
                                  <button
                                    type="button"
                                    className=" p-1 rounded-md ring-1 ring-slate-300"
                                    onClick={handleCreateRow}
                                  >
                                    <BiPlus size={"1.2rem"} />
                                  </button>
                                )}
                              </div>
                              <button
                                type="button"
                                className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute -left-8"
                                onClick={() => handleDeleteRow(row.id)}
                              >
                                <MdDeleteOutline size={"1.2rem"} />
                              </button>
                              <p
                                className={` bg-slate-200 flex items-center justify-center  ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              >
                                {index + 1}
                              </p>

                              {/* ACTUAL PROFESSION / JOB POSITION */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "job_position_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.job_possition?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* VISA PROFESSION */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "visa_profession_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.visa_profession?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* PROFESSION LEVEL */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "profession_level_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.profession_level?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* GENDER */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "gender",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                <option value="FEMALE">FEMALE</option>
                                <option value="MALE">MALE</option>
                              </select>

                              {/* NATIONALITY */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "nationality_id",
                                    e.target.value
                                  )
                                }
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.nationality?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* QUANTITY */}
                              <input
                                type="text"
                                className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                placeholder="ENTER QUANTITY"
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "quantity",
                                    e.target.value.toUpperCase()
                                  )
                                }
                              />
                            </>
                          )}
                          {section.columns.map((column) => (
                            <input
                              key={`${row.id}-${column.id}`}
                              type="number"
                              min={0}
                              step={"0.0001"}
                              className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              placeholder="Enter Cost"
                              value={column.cost}
                              required
                              onChange={(e) =>
                                handleUpdateColumn(
                                  row.id,
                                  column.rate_category_id,
                                  column.id,
                                  "cost",
                                  parseFloat(e.target.value),
                                  column.rate_category_item_name
                                )
                              }
                            />
                          ))}
                          <input
                            type="text"
                            className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            placeholder="Total"
                            disabled={true}
                            value={Number(
                              section.columns.reduce(
                                (accumulator, currentObject) =>
                                  accumulator +
                                  Number(currentObject?.cost || 0),
                                0
                              )
                            ).toFixed(2)}
                          />
                        </div>
                      </div>
                    ))}
                    {quotationDetails?.quotation_type?.name == "Hourly" && (
                      <div className="flex flex-col relative">
                        {index === 0 && (
                          <>
                            <div
                              className={`w-full text-white bg-zinc-800 py-2`}
                            >
                              <h2 className="text-center">Total</h2>
                            </div>
                            <div className={`flex w-full gap-1 `}>
                              <h3
                                className={`flex justify-center items-center text-sm bg-zinc-300 ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                              >
                                Per Hour Rate
                              </h3>
                            </div>
                          </>
                        )}
                        <div className="flex w-full gap-1 relative">
                          <input
                            type="text"
                            className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties?.colWidth} ${tableProperties?.colHeight}`}
                            placeholder="Total"
                            disabled={true}
                            value={(
                              Number(
                                row?.sections?.reduce(
                                  (accumulator, currentObject) => {
                                    const sectionSum =
                                      currentObject?.columns?.reduce(
                                        (colAccumulator, column) =>
                                          colAccumulator +
                                          Number(column?.cost || 0),
                                        0
                                      );
                                    return accumulator + Number(sectionSum);
                                  },
                                  0
                                )
                              ) /
                              26 /
                              Number(quotationDetails?.hour_type)
                            ).toFixed(2)}
                          />
                        </div>
                      </div>
                    )}
                    <div className="flex flex-col relative">
                      {index === 0 && (
                        <>
                          <div className={`w-full text-white bg-zinc-800 py-2`}>
                            <h2 className="text-center">Total</h2>
                          </div>
                          <div className={`flex w-full gap-1 `}>
                            <div
                              className={`${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative bg-zinc-300`}
                            >
                              <h3 className="text-center text-sm">
                                Total Monthly Per Head Cost
                              </h3>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="flex w-full gap-1 relative">
                        <input
                          type="text"
                          className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          placeholder="Total"
                          disabled={true}
                          value={Number(
                            row.sections.reduce(
                              (accumulator, currentObject) => {
                                const sectionSum = currentObject.columns.reduce(
                                  (colAccumulator, column) =>
                                    colAccumulator + Number(column?.cost || 0),
                                  0
                                );
                                return accumulator + Number(sectionSum);
                              },
                              0
                            )
                          ).toFixed(2)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
                {/* <button
                  className="bg-red rounded-md p-2 px-4 w-full max-w-xs text-white absolute left-1/2 mt-10 cursor-pointer text-sm"
                  type="submit"
                  disabled={submitLoading}
                >
                  {submitLoading ? (
                    <LoadingWithLable className={"!mt-0 text-white "} text={'SUBMITTING'} />
                  ) : (
                    `SUBMIT`
                  )}
                </button> */}
                <div className="absolute left-1/2 flex  w-full max-w-xs mt-16 gap-4">
                  <button
                    className="ring-1 ring-black dark:ring-red uppercase w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
                    type="button"
                    disabled={submitLoading}
                    onClick={() => {
                      navigate(`/dashboard/contract/${contractId}`, {
                        state: { detailType: "COST SHEET" },
                      });
                    }}
                  >
                    CANCEL
                  </button>

                  <button
                    className="bg-red rounded-md  text-white  p-2 px-10 cursor-pointer text-sm
                        disabled:bg-rose-400
                    "
                    type="submit"
                    disabled={submitLoading}
                  >
                    {submitLoading ? (
                      <LoadingWithLable
                        className={"!mt-0 text-white "}
                        text={"SUBMITTING"}
                      />
                    ) : (
                      `SUBMIT`
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </>
      ) : (
        <LoadingWithLable />
      )}
    </div>
  );
}
